<template>
    <div class="field">
        <div class="control has-icons-left">
            <input v-model="carYear"
                   v-bind:class="{ 'is-danger': error && error.length > 0 }"
                   class="input"
                   type="number"
                   placeholder="Type Year"
                    id="year">
            <span class="icon is-small is-left">
                <i class="fas fa-cogs"></i>
            </span>
            <p v-if="error && error.length > 0" class="help is-danger">{{ error[0] }}</p>
        </div>
    </div>
</template>

<script>
    export default {
        computed: {
            carYear: {
                get: function () {
                    return this.$store.getters.getNewCarYear
                },
                set: function (value) {
                    this.$store.dispatch('setNewCarYear', value)
                }
            },
            error: {
                get: function () {
                    return this.$store.getters.getNewCarErrorYear
                }
            }
        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Cars/Create/Inputs/YearInput.vue